import React from 'react'
import imageOne from '../../resource/aboutus/History pack/F1.png'
import bottomImage from '../../resource/aboutus/History pack/F2.png'
import TitleChnage from '../../Hook/TitleChnage'

import imageTwo from '../../resource/aboutus/History pack/4.jpg'
import imageThree from '../../resource/aboutus/History pack/1.jpg'
import imageFour from '../../resource/aboutus/History pack/2.jpg'
import imageFive from '../../resource/aboutus/History pack/3.jpg'
import imageSix from '../../resource/aboutus/History pack/2.png'




const History = () => {

    TitleChnage("History")

    return (
        <div className="history-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>
            <div className="main-content">
                <h1 className='text-center'>History of the Monastery</h1>
                <h3 className='mt-4'>Bhaddeka Vihari Forest Monastery and retreat Center</h3>

                <h4 className='mt-4'>The Place to reside in Noble solitude</h4>
                <p className='mt-4'><span className='bigT'>T</span>he Bhaddeka Vihari Forest Monastery and Retreat Centre, located in Ripplebrook in the Gippsland region of Victoria, Australia, offers an exemplary setting for spiritual practice and retreat. This centre occupies a picturesque 42-acre property, which was formerly a luxury countryside motel. Located approximately one and a half hours from Melbourne,</p>
                <p>The Bhaddeka Vihari Monastery and Meditation Centre, located in Ripplebrook in the Gippsland region of Victoria, Australia, offers an exceptional environment for spiritual practice and retreat. Situated on a picturesque 42-acre property, formerly a luxury countryside motel, the centre provides an ideal escape from the hustle and bustle of city life. Approximately one and a half hours from Melbourne, Ripplebrook is a quiet and serene countryside suburb, surrounded by lush green farmlands. The expansive green grasslands and scenic views stretching to the horizon create a perfect atmosphere for meditation, reflection, and spiritual growth—aligning with the core purpose of the Bhaddeka Vihari Monastery and Meditation Centre.</p>
            </div>

            <img src={imageThree} alt="" style={{ width: "100%" }} />

            <h1 className='text-center mt-6 font-second'>Bhaddeka Vihari Means ......</h1>
            <h1 className='text-center mt-4 font-second left-6'> 'Resides in Noble Solitude'.</h1>

            <p className='main-content'>The name "Bhaddeka Vihari" is derived from the timeless wisdom of the Pali Canon, inspired by the profound teachings of the “Bhaddekaratta Sutta”. It beautifully embodies the essence of mindful living, dwelling in the present moment, and cultivating wisdom and inner peace.</p>

            <div className="p-4 grid-elemnt pb-4">
                <div className="left-one">
                    <div className="text-center">
                        <img src={imageSix} alt="" style={{ width: "50%" }} />
                    </div>
                    <p className='mt-6'>The message of the 'Bhaddekaratta Sutta' is , a wise one who knows that there is no agreement with 'King of Death' engages relentlessly and ardently in pierce insight
                        meditation practice day and becomes ideal lover of solitude
                    </p>

                    <p className="mt-5 h5">
                        The theme of 'Residing in Noble Solitude' for both the Sangha and laity serves as the foundational reason for establishing the Bhaddeka Vihari Monastery and Retreat Center
                    </p>

                </div>
                <div className="right-one">
                    <h1 className='text-center font-second  '>Bhaddekaratta Sutta</h1>
                    <p className='text-center text-black text-bold mt-4'>Bhaddekaratta means  ‘The lover of Noble Solitude’. </p>
                    <p className="mt-4 text-black">
                        Lord Buddha gave the sermon “Bhaddekaratta Sutta” at Saavatthi in the Jeta Grove, Anaathapindika's monastery .
                    </p>
                    <p className="text-black">(Majjhima Nikāya. 131 Bhaddekaratta Sutta.)</p>

                    <p className="mt-4 text-black">atiaṃ na anvāgamayet , na pratikāṅkṣeta anāgatam
                        yad atītaṃ tat praheyam, aprāptaṃ ca anāgatam</p>
                    <p className="text-black">The past should not be traced back</p>
                    <p className="text-black">nor the future wondered about</p>
                    <p className="text-black">the past has passed away</p>
                    <p className="text-black">unreached is the future
                    </p>

                    <p className="mt-4 text-black">pratyutpannaṃ ca yo dharmam, tatra tatra vipaśyati</p>
                    <p className="text-black">and the present whatever phenomenon</p>
                    <p className="text-black">is as it is, one sees (with insight)</p>
                    <p className="text-black">invincibly, unshakeably</p>
                    <p className="text-black">of that which can be pierced by penetration</p>

                    <p className="mt-4 text-black">adyaiva kṛtyam ātapyam ko janīyād maraṇaṃ śvaḥ</p>
                    <p className="text-black">even today the effort must be made</p>
                    <p className="text-black">who knows? Death may come tomorrow</p>
                    <p className="text-black">there is no bargaining with</p>
                    <p className="text-black">the great army of the king of death</p>

                    <p className="mt-4 text-black">evaṃ vihāriṇam ātāpinaṃ ahorātram atandritam</p>
                    <p className="text-black">thus abiding ardently</p>
                    <p className="text-black">by day and night relentlessly</p>
                    <p className="text-black">' the lover of noble solitude '</p>
                    <p className="text-black">him the tranquil Sage has called</p>

                </div>
            </div>

            <img src={imageFour} alt="" style={{ width: "100%" }} />




            <div className="section-three">
                <h1 className='mt-4 font-second'>Significance of a Retreat Center</h1>

                <p className='mt-4'>In contemporary society, individuals often experience well-being through material pursuits, with numerous opportunities for entertainment and worldly engagements that cater to these needs. However, this focus on external fulfillment makes the attainment of ‘Noble Solitude’ increasingly elusive.</p>

                <p className='mt-4'>In contrast, distancing oneself from the fast-paced, busy atmosphere to embrace peace and tranquility within the mind—even occasionally—can significantly alleviate misery. This truth underscores the necessity for a societal refuge where individuals can retreat from the hectic world and immerse themselves in a serene environment to enjoy inner peace and ‘Noble Solitude.’ Hence, the establishment of a forest monastery and retreat centre becomes imperative, providing a space where one can withdraw from daily chaos and find solace in quiet contemplation.</p>


            </div>


            <div className="p-4 mb-4">
                <h1 className='mt font-second'> Foundational Step with the Prominent Sangha</h1>
                <p className='mt-4'>The Monastery was initiated in 2017 by the Most Venerable Wegodapola Wimalagnana Maha Thero of Bhaddeka Vihari Aranya, Thanjan Thenna, Balangoda, Sri Lanka. He graciously accepted the invitation extended by the Buddhist community of Melbourne, Victoria. This initiative soon expanded to include the creation of the Monastery and Meditation Centre, addressing a longstanding need within the community</p>
                <p className='mt-4'>The project was officially inaugurated in July 2017, and within the first six years, significant progress has been made, ensuring that its completion is well within reach.</p>
            </div>


            <img src={imageFive} alt="" style={{ width: "100%" }} />




            <div className="section-four">

                <h1 className='mt-4 font-second'>Our present position</h1>


                <p className='mt-4'>The current state of the premises enjoys essential facilities that provide a comfortable environment for both the Sangha and lay devotees. Key facilities include:</p>



                <ul className='unorderd-list mt-4'>
                    <li><b>Peaceful Sangha House</b>: Nestled atop a hill, this house comfortably accommodates around ten members of the Sangha.</li>
                    <li><b>Spacious Dhamma Hall</b>: Centrally located, this hall is designed to host large gatherings of Dhamma events.</li>
                    <li><b>Well-equipped Dana Hall and Kitchen</b>: These facilities are in place to prepare and offer ‘Pindapatha’ to the Sangha.</li>
                    <li><b>Existing Three Cottages</b>: These shared accommodations provide comfortable lodging for residents.</li>
                    <li><b>New Yogi Kuti Complex</b> : With 26 Kutis available for yogis, each with en-suite facilities, the complex also includes two specially designed Kutis to accommodate individuals with disabilities. </li>
                </ul>


                <h1 className='mt-4 font-second'>Accommodation for Residential Yogis</h1>

                <p className='mt-4'>The ongoing project will earth considerable developments, including the construction of a new building complex with 12 kutis, each equipped with necessary facilities. Among these, 2 kutis will have additional amenities to accommodate individuals with disabilities. This expansion will enhance the comfort of seasoned devotees and extend a warm invitation to newcomers.</p>

            </div>

            <img src={imageTwo} alt="" style={{ width: "100%" }} />

            <div className="section-four">



                <h1 className='mt-4 font-second'>The services we offer</h1>

                <p className='mt-4'>Currently, the Retreat Centre offers weekly and monthly meditation programs, along with regular special Dhamma programs for individuals of all ages. These programs are followed by various religious ceremonies and rituals. Information about all meditation programs can be found under "Meditate with Us," and details on religious ceremonies and rituals can be found under "Events."</p>
                <p className="mt-4">The Bhaddeka Vihari Monastery and Meditation Centre continues to expand its services and facilities, ensuring that it meets the spiritual needs of the community and provides a serene, supportive space for meditation, reflection, and growth.</p>
            </div>



            <div className="bottom-box">
                <img src={bottomImage} alt="bottom-image" width={400} />
            </div>
        </div>
    )
}

export default History